// extracted by mini-css-extract-plugin
export var cancelButton = "_nd-5";
export var content = "_nd-3";
export var createButton = "_nd-6";
export var drawerContainer = "_nd-0";
export var footer = "_nd-2";
export var header = "_nd-1";
export var orderFormColumn = "_nd-4";